import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { get } from '../../services/http'
import { SliceStatus } from '../../interfaces/Redux';
import { IContent, defaultContent } from '../../interfaces/Content';
import routeListen from '../../services/routeListen';

export interface AppState {
  content: IContent,
  status: SliceStatus,
  error?: string
}

const initialState: AppState = {
  content: defaultContent,
  status: SliceStatus.initial,
  error: '',
}
  
export const contentSlice = createSlice({
  name: 'content',
  initialState,
  reducers: {
    reset: (state, action) => {
      state.status = SliceStatus.idle
    },
    clearContent: (state) => initialState
  },
  extraReducers(builder) {
    builder
      .addCase(fetchContent.pending, (state, action) => {
        state.status = SliceStatus.loading;
        state.error = undefined;
      })
      .addCase(fetchContent.fulfilled, (state, action) => {
        if(action.payload) {
          state.status = SliceStatus.succeeded;
          state.content = action.payload;
          state.error = undefined;
        }
      })
      .addCase(fetchContent.rejected, (state, action) => {
        state.status = SliceStatus.failed
        state.content = defaultContent;
        state.error = action.error.message
      })
  }
})

export const fetchContent = createAsyncThunk('content/fetchContent', async ({ id, signal }: { id: string; signal?: AbortSignal }) => {
    const { data } = await get(`api/app/${routeListen.appGuid()}/content/${id}?language=${window.navigator.language}`, { signal })
      .catch((response) => {
        throw new Error(response.message);
      }
    );

    if (data) {
      return data as IContent;
    }

    return defaultContent;
  }
);

// Export reset reducer
export const { reset, clearContent } = contentSlice.actions 

export default contentSlice.reducer